// extracted by mini-css-extract-plugin
export default {"wrapper":"Routes_wrapper__He5qL","welcomeWrapper":"Routes_welcomeWrapper__ErPmI"};